import { CHART_COLORS } from './colors'

export const TVL_BREAKDOWN_COLORS = Object.values(CHART_COLORS).map((v) => `rgb(${v})`)
